/**
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Import portions of React that are needed.
import React from 'react'; // Other standard imports.

import { string } from 'prop-types';
export var HTTPErrorSvg403 = function HTTPErrorSvg403(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1584 916",
    className: className,
    preserveAspectRatio: "xMinYMax meet"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M412 617.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M416 624.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M398.19 625.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M402.19 632.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M384.33 633.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M388.33 640.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M370.48 641.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M374.48 648.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M356.62 649.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M360.62 656.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M342.76 657.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M346.76 664.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M328.91 665.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M332.91 672.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M315.05 673.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M319.05 680.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M301.19 681.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M305.19 688.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M287.34 689.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M291.34 696.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M273.48 697.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M277.48 704.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M259.62 705.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M263.62 712.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M245.77 713.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M249.77 720.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M231.91 721.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M235.91 728.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M218.05 729.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M222.05 736.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M204.2 737.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M208.2 744.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M190.34 745.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M194.34 752.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M176.49 753.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M180.49 760.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M162.63 761.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M166.63 768.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M148.77 769.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M152.77 776.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M138.92 768.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M134.92 775.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M125.06 760.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M121.06 767.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M111.2 752.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M107.2 759.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M97.35 744.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M93.35 751.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M83.49 736.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M79.49 743.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M69.63 728.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M65.63 735.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M55.78 720.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M51.78 727.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M41.92 712.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M37.92 719.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M28.06 704.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M24.06 711.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M14.21 696.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M10.21 703.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient",
    x1: 247.19,
    y1: 585.38,
    x2: 201.66,
    y2: 559.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#bebebe",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-2",
    x1: 277.37,
    y1: 578.09,
    x2: 217.77,
    y2: 543.68,
    xlinkHref: "#prefix__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-3",
    x1: 410.05,
    y1: 763.45,
    x2: 1315.84,
    y2: 763.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e0e0e0",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e2e2e2",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e4e4e4",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e7e7e7",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ececec",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f1f1f1",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f7f7f7",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fefefe",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__Shadow_Grey_70-100",
    x1: 378.57,
    y1: 642.11,
    x2: 450.16,
    y2: 600.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix___10-20-30",
    x1: 348.88,
    y1: 549.96,
    x2: 449.94,
    y2: 491.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-4",
    x1: 380.27,
    y1: 481.17,
    x2: 464.73,
    y2: 627.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ababab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d8d8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-5",
    x1: 375.64,
    y1: 577.88,
    x2: 471.73,
    y2: 577.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix___30-40",
    x1: 412,
    y1: 526.8,
    x2: 412,
    y2: 441.09,
    xlinkHref: "#prefix__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-6",
    x1: 369.1,
    y1: 561.12,
    x2: 444.49,
    y2: 561.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-7",
    x1: 391.78,
    y1: 563.28,
    x2: 408.79,
    y2: 553.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d8d8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__White_100_-0_",
    x1: 358.01,
    y1: 494.65,
    x2: 447.52,
    y2: 546.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fdfdfd",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#fbfbfb",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f7f7f7",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#f3f3f3",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ededed",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e6e6e6",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#dfdfdf",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d6d6d6",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0d0d0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("style", null, '.prefix__cls-1{fill:none}.prefix__cls-80{opacity:.25}.prefix__cls-75{fill:#595655}.prefix__cls-76{opacity:.15}.prefix__cls-77{fill:#373d42}.prefix__cls-78{fill:#002b50}.prefix__cls-80{mix-blend-mode:multiply}.prefix__cls-81{fill:#2b2828}')), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: 'isolate'
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__linear-gradient)",
    d: "M241.86 594.61l-39.98-31.72 5.11-13.03 40.83 23.57-5.96 21.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.62 544.67l44.38 22.7 9.65 8.59-10.18-3.39c-6-2-5.28 1.53-8.38 1.27l-.45-.15-44.36-25.62z",
    fill: "url(#prefix__linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    strokeDasharray: "0 16",
    stroke: "url(#prefix__linear-gradient-3)",
    fill: "none",
    d: "M414.05 620.91l336.71 194.4 202.03-116.64L1311.84 906"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(412 609)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfElEQVQ4T6WSSw7AIAhEh6Ynbc/lWemmYwz+hvatTMQXYDR3Rwa7UR94gfF8jMvHtJLuTuloJWBX56wAWAsi09FUCeu60VRBpI72VUAMl7BtgVT8M7zAfouk+Fe0vxp4U8ssOgpIjX8nmwmItKOdBAgfMnalCMhw2RkBeQAZxjPT3pNTOgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(412 617)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW22NyQ0AIAzD3I4KczGreRVxRcrHjhRoqrI3+SQBouMBHcQtEqDEASu1XnBfP+/RcQKavRjGL3PgMAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-2)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(398 617)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAe0lEQVQ4T52SQQ7AIAgEF9OXtu/qW+mh2YYqCjJH3UxWQVQVu8gFBQC9Ifb88OM+lEzvM81WEttuKYuaEArbLJAVWYZmFQnwtvsGUJVYBGdiAkm2VmNGOIAsw2pU/qvffqDwTE9CWhSwRLlUs0hCfkvb/11WQtxmuxLyAMz2NejKo2qaAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(398 617)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfUlEQVQ4T52SQQ6AMAgEl0b9qT7Kp3rBg8HQlhbKHBsy2cISM2OV4wIDwHOD9Ptmj9uIZARFks0kOt1U5iURRFhGA1GRpkuWkQBfuv8AWYmG9jNwgSBL1RjhHiBKV43Mvtr2A4lvWhKheAMaby6UzJMIVWnb3UUlgplsVSK8+4c10Eqd9NYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(398 625)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW13KQQoAIRADwTagP9VH7VP3Ek8j0YaBIRR92rbJE8BYmEj/R+NJ9aQWwKtFVPqMqS9ZegPgpxjWGWi8pgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-4)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(384 625)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62SQQ6AMAgEl8b6U32UT/WyHkwbWlFo4yRcKJlQskISo6w7CADnAdF9GZEViUYLl/7RwpJYJG/AE+n31808icXjZjMS4L5d3WxWohGSv4gAQPI2kI0Pmm/OonM2/c0+/UAwtBpLUkjegMabC23mSQpNaPvbRSUVkk3ljex70boAY4JtrFm3DDgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-5)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(384 625)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62SQQ6AIAwEt8QTvlQf5E89rwcDKVhtIU7SS2kmpVkhiVHWHQSA84DovozIikSjhUv/aGFJLJI34In0++tmnsTicbMZCXDfrm42K9EIyV9EACB5G8jGB803Z9E5m/5mn34gGFqNJSkkb0DjzYU28ySFJrT97aKSCsmm8kb2vWhd8Fltvk/Ar5YAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(384 633)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW12NQQoAIAzDsh71pfogf+q5nobTQGGU0NGGbZsaAfSJKWgvgg/lUW0B/LYopB32/ZHlY+bMAV2CG+SXNHwdAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-6)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(370 633)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAiElEQVQ4T62SSw6AIAwFp8SVnlQP5E1Z14XBFC3fOEsKk7Y8UVVG2Q4UIJ6IPZcRWZJYrHB5Fz08iUdoXWiJbL3YWUvi8dnZjATu3T2yWYklwD8iAFn3gWxUiCfSFY0aNmeiqlNjvtMPHTnz8ERgotHTXUmSyHJWErYkieoH9EoS2c7s41ERwAW31Tt9krezkQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-7)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(370 633)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAiUlEQVQ4T62S3Q2AIAwGr8QBdE+dxkEZoT4YTNHyG++RwqUtn6gqo2wHChBPxJ7LiCxJLFa4vIsensQjtC60RLZe7Kwl8fjsbEYC9+4e2azEEuAfEYCs+0A2KsQT6YpGDZszUdWpMd/ph46ceXgiMNHo6a4kSWQ5KwlbkkT1A3oliWxn9vGoCOACVpM7htbSFKUAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(370 641)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12MwQkAIAwDz05g99RpHNQR4itSPQiU5Ch9SJKoCYCciELsReMjfFQ7AGx7uGZ9c0uTEz2l7QNaBxp9mmUCYwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-8)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(356 641)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU3Q2AIAwGr4YBdE+dhkEZob5IUgk/rd4jJUchXxFVJcpxoQAlI3ZdIrIqsVjh1hZH9EQty848ktrdUOaRWEpGUrsYlVhenf0RAST4L6nIfgayMaH7ZlFszkRVP12zTT88oe0VZoz2h665OtQVjZWkspxNrwg64zT6XjzcHcY+iLkUDUEAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-9)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(356 641)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU3Q2AIAwGr4YVdE0dhTlZor5IUgk/rd4jJUchXxFVJcpxoQAlI3ZdIrIqsVjh1hZH9EQty848ktrdUOaRWEpGUrsYlVhenf0RAST4L6nIfgayMaH7ZlFszkRVP12zTT88oe0VZoz2h665OtQVjZWkspxNrwg64zT6XjzcXJk+gIae2IIAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(356 649)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW12KsQ0AIAzDTH+AN+EU7uSJMAW1RMpimz4lSeQHwFiItDib9osAsCjQc/1grkvpukDXF6BcGoU83G4KAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-10)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(342 649)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU0Q3AIAhEj8YV2jXbUZzTJa4fDQk1UMW+TzQvYA6FJLIcFwgArUJsXTIylViscOsPIzxRXy/eBUsk8QjHzEiAZ1x3zKxIeXW2KlEK8F+iyH4msvFBqxAh+auzpZx5hBuQ6a6XKMPQWiKJMhWNkUQZvtmsCHDWKfpeZrgBHEY+kpxsXeMAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-11)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(342 649)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU0Q3AIAhEj8Yp2i3bORzTOa4fDQk1UMW+TzQvYA6FJLIcFwgArUJsXTIylViscOsPIzxRXy/eBUsk8QjHzEiAZ1x3zKxIeXW2KlEK8F+iyH4msvFBqxAh+auzpZx5hBuQ6a6XKMPQWiKJMhWNkUQZvtmsCHDWKfpeZrgBsd0+qjiv79QAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(342 657)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12NwQ0AIAjEqmPIljKHYzrH+REj9HU0TWhjSgB70bj0/3gyhjlKstadj6ifTI8omKMkoz6Kxg6AwHBi6AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-12)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(328 657)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T6WT0Q2AIAxEr4YpdEudgzGZo36YM5VQoPK+SCgvVwqiqohyXHgPlQzhemuX+1hRjcwm60mYLnkFpCepcZNFJMCTrnlnURH5JPsrIQlYlxDZz8lxDigZIqq6lGzp0VqsCDADiKSrJWT4aC2ehLxtjgpH+0DjB9TtzkiI22ZEQm7JxzoJmU9N7wAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-13)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(328 657)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T6WT0Q2AIAxEr4Y9dEqdgS3ZpH6YM5VQoPK+SCgvVwqiqohyXHgPlQzhemuX+1hRjcwm60mYLnkFpCepcZNFJMCTrnlnURH5JPsrIQlYlxDZz8lxDigZIqq6lGzp0VqsCDADiKSrJWT4aC2ehLxtjgpH+0DjB9TtzkiI22ZEQm5ExzoJ1mFIlwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(328 665)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12MsREAIAjEgovolDqDW7rJ2wgHpoJcwPqUAM7GeLS8hPRhLFTkXzcSXpsUVyFL6W+KdC43XBAJ1fTySwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-14)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(315 665)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WSwRGAIAwEL459aJVaA13SCX48hokED90Xj7CTXGKlFMywn6gfcoLxvfTL+7QSjykdjQTsao0KgLHAE46mSlj3GE0VeOpoXwXEtkNIW2Bq/RE5wX6LpPWPaK8auLc2E7QXkLr+N1kkIFJGbxLAHaTvShGQbtgzAnIBfJg0OenSruAAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-15)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(315 665)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WSwRGAIAwEL46laJFaAE1SDH48hokED90Xj7CTXGKlFMywn6gfcoLxvfTL+7QSjykdjQTsao0KgLHAE46mSlj3GE0VeOpoXwXEtkNIW2Bq/RE5wX6LpPWPaK8auLc2E7QXkLr+N1kkIFJGbxLAHaTvShGQbtgzAnIBBJk0SQHk8K8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(315 673)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW22NsQ0AIAzDTG+BI+kBPMkxYSqiQKQsdqRQuySJs8YnBtAcJTgH5RYGECLBSKw3PNfPe3O0AM25GTxv/3OKAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-16)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(301 673)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52S0Q2AMAhEj8ZRdEgdwCUdBj8Mhra0UN5nQ16ucMTMWOW4wADw3CD9vtnjNiIZQZFkM4lON5V5SQQRltFAVKTpkmUkwJfuP0BWoqH9DFwgyFI1RrgHiNJVI7Ovtv1A4puWRCjegMabCyXzJEJV2nZ3UYlgJluVCC8khDU35o/ODwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-17)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(301 673)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52SQQ6AMAgEl8bP6Bv15B/9Dh4Mhra0UObYkMkWlpgZqxwXGACeG6TfN3vcRiQjKJJsJtHppjIviSDCMhqIijRdsowE+NL9B8hKNLSfgQsEWarGCPcAUbpqZPbVth9IfNOSCMUb0HhzoWSeRKhK2+4uKhHMZKsS4QVTFTUfIOHfXQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(301 681)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW13KwQkAIRBD0W+60Rr1tD1uO/E0Ev0wMIRHn7Zt8gQwFibS/9F4Uj2pBfBqEZU+Y+pLlt4TshlMVmb5VgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-18)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(287 681)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAh0lEQVQ4T62SQQ6AMAgEl8bP1DfqyT/6nfVg2tCKQhsn4ULJhJIVkhhl3UEAOA+I7suIrEg0Wrj0jxaWxCJ5A55Iv79u5kksHjebkQD37epmsxKNkPxFBACSt4FsfNB8cxads+lv9ukHgqHVWJJC8gY03lxoM09SaELb3y4qqZBsKm9k34vWBf7+biLcajJbAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-19)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(287 681)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62SQQ7AIAgEF9P/2B/WJ/ZH20OjQUsLmk7CBckEyQpJzLIXEADOAtF9mZFViUYLt/HRwpJYJG/AE+n31808icXjZisS4L5d22xVohGSv4gAQPIxkY0Pum+uonO2/M0x/UAwtBpLUknegMabC23mSSpdaMfbRSUNkl3lgxx70boAi+ZuNMg4FtEAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(287 689)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAO0lEQVQIW12NwQkAIAwDr1lIN7QjulF8FasHgRKOlLFs2/QIYCamoZ0EH6qj2wL4bdEoO+z7o8rHrJkDnAYcWhaPDkEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-20)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(273 689)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAh0lEQVQ4T62SSw6AIAwFp8b76A3liNyoLgymYPnGWVKYtOWJqjLLGVCAGBB7LjOyJLFY4V4WPTyJx9a70BPZerWznsTjs7MVCTy7e2WrEssG/4gA5LgmstEgBmQoGi1szkRVl8Ys0w8DOfPwRGCiMdJdTZLIclYT9iSJ5geMShLZzuzjWRHADchRO7i9KjJ6AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-21)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(273 689)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T62SSw7AIAgFB9Mr9XYuezsPRReNDbX4jbMUnQA+UVVmOS8UIEXEnsuMLEssVniURQ9P4hF6F3oiW6921pN4/Ha2IoFnd69sVWIJsEcEEHaJUkSGotHC5kxUdWnMMv0wkDMPTwQmGiPd1SSZT85qwp4k0/yAUUnmszP7eFYEcAMLijrF4vT/KwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(273 697)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12MwQkAIAwDz85kt/On2zlUfEWqB4GSHKVPSRI1AZALUYg9aHyEj2oHgG0P16xvbmlyoae0fQCQGRq4KaWHHQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-22)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(259 697)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62UwQ3AIAgAD+NK3c5nt3Mo+qkJNVqh9p5gTjCgqCpRjhMFqAWxcYnImsRihalPzhiJepaVeSStuqnMI7HUguQ+GJVYHpXtiAAy7Esa6S/R8M2i2DkTVf3UZj/9cA/tKPHG7HyozdWlrtFYSRrL3fSKYLBOs+/FwwWRpj1RLfDqigAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-23)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(259 697)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62UwQ3AIAgAD+NU3cwJuplr0U9NqNEKtfcEc4IBRVWJcpwoQC2IjUtE1iQWK0x9csZI1LOszCNp1U1lHomlFiT3wajE8qhsRwSQYV/SSH+Jhm8Wxc6ZqOqnNvvph3toR4k3ZudDba4udY3GStJY7qZXBIN1mn0vHi7QeT1JFgA9ngAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(259 705)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW12KsQ0AIAzDTL+Cz3gAPuOtMAW1RMpim74kSeQHwNiItDiT9osAsCjQc/1grkvpukDXF9ZuGsBmSXR4AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-24)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(245 705)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62U0Q3AIAhED+NU3cwJuplrXT8aEmogivZ9onkBcygkkeW6QQDoDWLrkpGpxGKFZTyM8ERjvXoXLJHEIxwzIwHecd0xsyLl09muRKnAuUQpf4l6gwjJo862cuYRbkCmu1GiTENriSTKUjRmEmX6ZqsiwFmn6HtZ4QEQNT5H6wcOUAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-25)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(245 705)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62U0Q3AIAhED+Ne3cohupWTXT8aEmogivZ9onkBcygkkeW6QQDoDWLrkpGpxGKFZTyM8ERjvXoXLJHEIxwzIwHecd0xsyLl09muRKnAuUQpf4l6gwjJo862cuYRbkCmu1GiTENriSTKUjRmEmX6ZqsiwFmn6HtZ4QGlzD5feNEAjwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(245 713)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12NwQ0AIAjEKoPpVu4gWznZ+RED9nU0TWh9SQB70rhYPp6MMRwV+ddGIuonyyM+hqMioz520A5FI5WFaAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-26)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(231 713)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4T62T0Q3AIAhEj8a9upVDdCsnox/NGWpEpfZ9mYgvh6KoKqKcF+qhkiFcH/1yHytqkdVkIwnTJa+AjCQtbrKIBHjSde8sKiKvZF8lJAH7EnL8JSoZIqq6lWxraC1WBJgHiKRrJWQ6tBZPQmqbs8LZPtD5AW27KxLithmRkBuUYzkNzMPF6gAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-27)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(231 713)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4T62T0Q3AIAhEj8bRupFzdCN3ox/NGWpEpfZ9mYgvh6KoKqKcF+qhkiFcH/1yHytqkdVkIwnTJa+AjCQtbrKIBHjSde8sKiKvZF8lJAH7EnL8JSoZIqq6lWxraC1WBJgHiKRrJWQ6tBZPQmqbs8LZPtD5AW27KxLithmRkBsBujkNpqthLQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(231 721)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12MsREAIAjEgqvpRq6hG7nb2wgHpoJcwPqSAM7EeLS8hPRhbFTkXzcSXpsUVyFL6W+KdC4wyhAJfDhffAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-28)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(218 721)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfElEQVQ4T6WSwRHAIAgEj4ylpSPrSEf2Zj45x0FRiPvygTvAIbVWRLgftA8lQ/i+5uVzeolGPB2tBOwqWQXAWqAxR/NKWDeM5hVo2mh/BSSdCkgofouSIcciV/wr+qsGvtQie9IC0uLfySwBce1oJwHUQequPAIyXXZEQF7XoTOzyj6GnwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-29)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(218 721)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfElEQVQ4T6WSwRHAIAgEj4zNpRprSTWWZz45x0FRiPvygTvAIbVWRLgftA8lQ/i+5uVzeolGPB2tBOwqWQXAWqAxR/NKWDeM5hVo2mh/BSSdCkgofouSIcciV/wr+qsGvtQie9IC0uLfySwBce1oJwHUQequPAIyXXZEQF5wnzPFUwUfFgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(218 729)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW22NyQ0AIAzDTKej07AKTMN44VVUjkj52JFC7ZIkco1PDMAHOuBslFsYQIgDRmK9YV4/7z7QAgDEGbL3Q18bAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-30)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(204 729)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52S0Q2AMAhEj8bhdBpX0WkcDz8Mhra0UN5nQ16ucMTMWOW4wQDwnCD9vtnjNiIZQZFkM4lON5V5SQQRltFAVKTpkmUkwJfuP0BWoqH9ClwgyFI1RrgHiNJVI7Ovtv1A4puWRCjegMabCyXzJEJV2nZ3UYlgJluVCC98AzSGrOWZawAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-31)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(204 729)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52S0Q2AMAhEj8b5dBG30UWcED8Mhra0UN5nQ16ucMTMWOW4wQDwnCD9vtnjNiIZQZFkM4lON5V5SQQRltFAVKTpkmUkwJfuP0BWoqH9ClwgyFI1RrgHiNJVI7Ovtv1A4puWRCjegMabCyXzJEJV2nZ3UYlgJluVCC+wZTRrp0g7RQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(204 737)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAO0lEQVQIW13K0QkAIRAD0TEFaiN24zVyFcavlejAwhIefdm2yRPA+DCR/knjSfWkFsCrRVT6jKkvWXoDR4wZxOG4ZqgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-32)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(190 737)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T62S0Q2AMAgFH43z6SJuo4s44fPD1FDEQJtewg+QCxCEJHrZThAArh2i89IjqxKNFi626OFJPErUEIl0/XeySOLxudmIBHhu9042KtEIySkiACizRM2ao+g/G17Tfj+QfFqNJ6mUqEET9aUmiySV5mnt7bKSF5JNrAdpc9m4AU6sbZ5q9kruAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-33)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(190 737)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T62S0Q2AMAgFH40b6hIupEu44/PD1FDEQJtewg+QCxCEJHrZThAArh2i89IjqxKNFi626OFJPErUEIl0/XeySOLxudmIBHhu9042KtEIySkiACizRM2ao+g/G17Tfj+QfFqNJ6mUqEET9aUmiySV5mnt7bKSF5JNrAdpc9m4Acveba417E+CAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(190 745)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12NwQkAIAwDr1lRl3AhXcId46tYPQiUcKS0adumRgB9YQrag+BDeVRbAL8tCmmHfX9k+Zg5cwDaiBzQhMcu8AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-34)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(176 745)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T62S3Q3AIAgGD9MRu4QTdQl3pA+NDbX4G+9R9AL4iaoyy3mhACki9lxmZFliscKjLHp4Eo/Qu9AT2Xq1s57E47ezFQk8u3tlqxJLgD0igLBLlCIyFI0WNmeiqktjlumHgZx5eCIw0RjpribJfHJWE/YkmeYHjEoyn53Zx7MigBt9SDr3geCsOQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-35)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(176 745)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T62S3Q3AIAgGD9Mlu4BDdQHHpA+NDbX4G+9R9AL4iaoyy3mhACki9lxmZFliscKjLHp4Eo/Qu9AT2Xq1s57E47ezFQk8u3tlqxJLgD0igLBLlCIyFI0WNmeiqktjlumHgZx5eCIw0RjpribJfHJWE/YkmeYHjEoyn53Zx7MigBsKZDr/bVjn/wAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(176 753)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12MwQkAIAwDz05pF3AnXcAx4ytSPQiU5Ch9SpKoCYBciELsQeMjfFQ7AGx7uGZ9c0uTCz2l7QPFQRryyo9D+AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(162 753)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62UwQ3AIAgAD+OSXcChuoBj0k9NqNEKtfcEc4IBRVWJcpwoQC2IjUtE1iQWK0x9csZI1LOszCNp1U1lHomlFiT3wajE8qhsRwSQYV/SSH+Jhm8Wxc6ZqOqnNvvph3toR4k3ZudDba4udY3GStJY7qZXBIN1mn0vHi5ZPj0XhHWjCwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-37)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(162 753)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfklEQVQ4T62UMQ7AIAgAD+M7O/iwDn6ULjWhRivU3gjmBAOKqhLlOFGAWhAbl4isSSxWmPrkjJGoZ1mZR9Kqm8o8EkstSO6DUYnlUdmOCCDDvqSR/hIN3yyKnTNR1U9t9tMP99COEm/MzofaXF3qGo2VpLHcTa8IBus0+148XJ/sPQ5VDtx8AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(162 761)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOElEQVQIW12KsQ0AIAzDTP+Egb9g4NEwBbVEymKbviRJ5AfA2Ii0OJP2iwCwKNBz/WCuS+m6QNcXDI8a+73Xk4YAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-38)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(148 761)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfklEQVQ4T62UQQ7AIAgEF+M7e/BhPfjR7aEhoQaiaOeIZgJmUUgiy3WDANAbxNYlI1OJxQrLeBjhicZ69S5YIolHOGZGArzjumNmRcqns12JUoFziVL+EvUGEZJHnW3lzCPcgEx3o0SZhtYSSZSlaMwkyvTNVkWAs07R97LCA1+oPvjGQ0E8AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-39)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(148 761)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62UwQ3AIAhFP62LdDIPLtJFPHS2DkIPDQk1EEX7jmhewHwkZkaUcoEBoGaQrlNEJhKNFm7toYclauvJuqDxJBbumBEJ8I5rjhkVCZ/OZiVCAtYlwn4f5y+imkHEzEudTeXMwt2ASHetROiGVuNJhKFo9CRC981GRYCxTt73MsIDKsU/kSq40GAAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(148 769)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW12NwQkAIAzEYhcVdC7BTnp+rNjmdQ2BtrElgNVpXOw/nowxHSVZa+Mj6ifTIwrTUZJRH2LaDgo5RZMHAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-40)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(134 769)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAiUlEQVQ4T62TwQ2AIAxFf9VFnIyDi7iIB2dzkHow31RChYrvREJ5+YUiqoooy4770JYgXA/lch8rypHWZG8Sppu8AvImyXGTRSTAla54Z1EReST7KiET0C8h4zGvv4i2BBFV7UrWNbQWKwLMA0TS5RJSHVqLJyF3m7XC2j5Q+AF5uy0S4rYZkZAT7/o5jjH/r8IAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-41)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(134 768)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WT0REAEQxEN1enBlSkAX3mvtxkdojl3i/Wi4S5OyK1wwGgFRgOeVYLtcNHsIpFs+ywYvqFqRZZ6LLMFdml5u6yFcOWx2YRbtJzaxUZGb/KZOTRUDD+AcBdaCuwaQNagSlDyqTdVAPHvu1onFhO3yyD3zNetDVjMtMXLMJEDa+ZJIwAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(134 768)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW23KwQ0AIAzDQLdzsgATsUD3DK8givDTupDE3SyUfGpzFmrTYw2iyTWII63ckVYA+SqADRqWECUVwCw/AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-42)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(121 760)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdQxGaCdiAHKnunLEkqBmHtWwb3E5u4gT4cDQKswHFJmH58OZ6iK0Wj3UDGcGkUUw8LB3RDZzdn9uhQSietKq82I6167YQWGFaURhQJo9WaYh1urDUZ+QeQksFXYMohkgTxLWr96v9RoJNqNP0mNRlqFrQw/do0+Q0Jl4UYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-43)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(121 760)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdQlGaIdhiHKmOnLEkqBmHtWwb3E5u4gT4cDQKswHFJmH58OZ6iK0Wj3UDGcGkUUw8LB3RDZzdn9uhQSietKq82I6167YQWGFaURhQJo9WaYh1urDUZ+QeQksFXYMohkgTxLWr96v9RoJNqNP0mNRlqFrQw/TX0+a4AUFc4AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(121 760)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPklEQVQIW2XKQQ0AIAzF0A7EoAkTaEADJnCHhc+JZRk9Ns8k8RobARRSq2M+n/rk6pjPqADqaVNRuYzDZ+4Cf98PjumwV5IAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-44)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(107 752)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhED7d0iDqMQ9Qxr182xBQB+/6IEd6BkMSkDbxFrxAkKdaDbhxFptnuc9TSNNO0AUZMhWQ6kmUaMluxhst1M2W1oi2PzDR6n0c7syhA/PQ7eoUUXfxtKjT2n4k+JcwDnJi61/Qa6ncz5hdr9HWQa6bxoj86tDzJ0jTAugAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-45)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(107 752)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhED3d0kTqHi9Qhr182xBQB+/6IEd6BkMSkDbxFrxAkKdaDbhxFptnuc9TSNNO0AUZMhWQ6kmUaMluxhst1M2W1oi2PzDR6n0c7syhA/PQ7eoUUXfxtKjT2n4k+JcwDnJi61/Qa6ncz5hdr9HWQa6bxoj+lczyufQ+ragAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(107 752)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOElEQVQIW2XKQRHAIAwAwQ0eUVIdKKnI8EqG0nvebGSm6nklDFdrip6lfnJN0fNUH1kKxq1ango2JaQPDXOwQYsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-46)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(93 744)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T6WUwQ3EIAwEd69HGrnUQSOhyL0XkmNpI5ubFzxsxsZASYhcCwKAOUA0+cTNTpTXVbjN3oKrlg8zx7WgiikltUtypiWzjDuc31stq0y0PDKLxH4e9czBOLT/JJ0DfJRZnScH83PadCy3hL2AOcCuqTXLONOj0ahYls0i7pv6AQ+KRXFet+DaAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-47)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(93 744)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T6WUwQ3EIAwEd69EmrmUQDOhxb0XkmNpI5ubFzxsxsZASYhcCwKAOUA0+cTNTpTXVbjN3oKrlg8zx7WgiikltUtypiWzjDuc31stq0y0PDKLxH4e9czBOLT/JJ0DfJRZnScH83PadCy3hL2AOcCuqTXLONOj0ahYls0i7pv6ActmRZFgXwSMAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(93 744)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW13KQREAMAjEwIBE1FQCamrx+oKh5JlZk8TsXOR7APgeGdgnM7CWpaqWpQB8q5ZTATwp+xEyj/4P5AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-48)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(79 736)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T52UwRHAIAgED0u0mpRgNbZ4eZm5OBIg+9ZjFdRIQrkmCACjw1DENGwFKZXQFi04FfB4zDKbIksjmQpSvNDwmCeuCZ4EWtVK2ff+MlPU8tedeYRzVuF1zKj1X4wOs/05LSqWS8JtwOiwqqlrtuOZasH0aGQs02aK903dUz5Hkc4uNVgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-49)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(79 736)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T52UwRHAIAgEDxu0orysyAovLzMXRwJk33qsghpJKNcEAWB0GIqYhq0gpRLaogWnAh6PWWZTZGkkU0GKFxoe88Q1wZNAq1op+95fZopa/rozj3DOKryOGbX+i9Fhtj+nRcVySbgNGB1WNXXNdjxTLZgejYxl2kzxvqkb9MpHsVvTab0AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(79 736)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW13LsRHAMAgEwUUNqiJHqsgV4ggN+MOdv8hMfc8r1x9gIJwtLtbrPgvOFiMvgNWzkfcXfPLBEToy4kOZAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-50)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(65 728)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WTwQ3EMAgEhzToivJyRamQezlaOURAbr62BxZhc3eU88IB5sBoYipbIqUjPbIL54VHRSJuWfYgO4dCZ0rWpbl7qWrEPs/jqwie0VsxIzT6XzF30j3rYPsPgG/SObBwZp2tV8LOlEqXq3gqW7xJNUV5NebAsvhl2UKFu/wHWslIPL6w6fcAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-51)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(65 728)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WTwQ3EMAgEh9TnmvxITemPezlaOURAbr62BxZhc3eU88IB5sBoYipbIqUjPbIL54VHRSJuWfYgO4dCZ0rWpbl7qWrEPs/jqwie0VsxIzT6XzF30j3rYPsPgG/SObBwZp2tV8LOlEqXq3gqW7xJNUV5NebAsvhl2UKFu/wHewtIdDE6A9IAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(65 728)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW2XKwQ2AMAwAMaesxBidqULMxH7hRRTgntZFZuqdlxxfgBfCmqLwuX7nmqKwX7CN/ch+1dkBbqbAEMOJ8S79AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-52)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(51 720)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4T6WTwQ3AIAwDnc7HTDyYif3cF1VkRYTQ+wLOEYKRhGdMEAB6g6GI+bAV5KmEPtmGMcGoSMQXlh3I1oEDM09maSSPqkZoP0tmipo+t1aelfHrmko6ZxVMfwBwF9obLHyA3mCVyV9sX/M0cO1LR6NiGfZsh/bTF0rNFH9YjV8wvUTZLi9QzAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-53)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(51 720)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WTwQ3AIAwDnU7HSIzASGznvqgiKyKE3hdwjhCMJDxjggDQGwxFzIetIE8l9Mk2jAlGRSK+sOxAtg4cmHkySyN5VDVC+1kyU9T0ubXyrIxf11TSOatg+gOAu9DeYOED9AarTP5i+5qngWtfOhoVy7BnO7SfvlBqpvjDavwCbm5FAWM+xNwAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(51 720)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW2XKOREAIBDAwD3UIQkJSMLdUcHwpMxsZKazPmR5B1wTWhV7LvXJVsWep7rkUlBeBROKcBCL4aY5zgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-54)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(37 712)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WT0REAEQxEN1edkpSgJN3tfbnJ7BDh3i/Wi4SRhKd1EABqgeGQZ7XQOjiCs5g3iw5nTL+wrEUUuixzRXSpkUxbKWp5bObRJj23Vp6R8atMJT0aGUx/AHAXWgts2oBaYJkhVcJuZgPHvu1onFhO3yxC39NftDVTItMXdwJEQOvj2eMAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-55)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(37 712)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WT0REAEQxEN9ebitShIsXtfbnJ7BDh3i/Wi4SRhKd1EABqgeGQZ7XQOjiCs5g3iw5nTL+wrEUUuixzRXSpkUxbKWp5bObRJj23Vp6R8atMJT0aGUx/AHAXWgts2oBaYJkhVcJuZgPHvu1onFhO3yxC39NftDVTItMXI05ESLhBIZ8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(37 712)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW23KwQ0AIAzDQLe7MRFzMFGHC68givDTupDE3SqUfGpzFWrTYw6iyTmII63ckVYA+SqADVMaEJscxlVcAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-56)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(24 704)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdTVmIg1ykJluPRlCaVA3HtWwb3E5u4gfcABoFUYflJWH/uAM1TFaHR6qBgujSKKYeHgaYic5ux+XAqJxHWl1VbEda/TsALDitKIQgG0ejPMw63VBiOfIPInsFXYNohkgTxLWr96v9RoJtrNP0mNZlqF7Qxfp54/ak8H7RcAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-57)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(24 704)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdTJGIhdyj5ltfRlCaVA3HtWwb3E5u4gfcABoFUYflJWH/uAM1TFaHR6qBgujSKKYeHgaYic5ux+XAqJxHWl1VbEda/TsALDitKIQgG0ejPMw63VBiOfIPInsFXYNohkgTxLWr96v9RoJtrNP0mNZlqF7Qxffo4/kulAuGUAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(24 704)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW2XKQQ0AMAjF0II0BCFmgmbt7wQhrMeXmiSqcxGAs8rAGuv6zgyscV4AXlBXnxMadw94LA8NAkRlXwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-58)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(10 696)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhEwdEcyF3qPnW165cNMT0B+/6IEd6BApBJH/IWrYpKksIebOMoOs12n6OW1MzShyBiqgDSkZhpyGyFDdfrRspqxVoemVnsPo92xigi8dPvaFW02OJvUwXZfyb6lKAHODF1r+k1tO805hdr9HWQa2bxoj/2kDwYiCNvlAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-59)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(10 696)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhEwcWcx4XqOnWy65cNMT0B+/6IEd6BApBJH/IWrYpKksIebOMoOs12n6OW1MzShyBiqgDSkZhpyGyFDdfrRspqxVoemVnsPo92xigi8dPvaFW02OJvUwXZfyb6lKAHODF1r+k1tO805hdr9HWQa2bxoj9VgDwAcXeIpAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(10 696)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOElEQVQIW2XKQRHAIAwAwQ3G0IOi6qmy8EqG0nvebGSm6nklDFdrip6lfnJN0fNUH1kKxq1ango2PEwPDeYK8vMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-60)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(-4 688)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T6WUwQ3EIAwEd68x6qGhSzuhsr0XkmNpI5ubFzxsxsZASYhcCwKAOUA0+cTNTpTXVbjN3oKrlg8zx7WgiikltUtypiWzjDuc31stq0y0PDKLxH4e9czBOLT/JJ0DfJRZnScH83PadCy3hL2AOcCuqTXLONOj0ahYls0i7pv6AWHPRlkBO2yyAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__Shadow_Grey_70-100)",
    d: "M357.11 604.94l28.62-16.57 85.91 49.61-28.63 16.52-85.9-49.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.09 528.25a4.12 4.12 0 00-1.37-1.41l-3.07-1.77-79.45-45.87a1.43 1.43 0 00-1.37-.17l-28.2 16.28c-.32.19 6 80.21 6 80.21l12 7.79 95.74-54.49a5.1 5.1 0 00-.28-.57z",
    fill: "url(#prefix___10-20-30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.09 610.67a1.39 1.39 0 00.64-1.33v-79a3.81 3.81 0 00-.35-1.51l-95.74 54.49 67.27 43.63z",
    fill: "url(#prefix__linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.09 610.67a1.39 1.39 0 00.64-1.33v-79a3.81 3.81 0 00-.35-1.51l-95.74 54.49 67.27 43.63z",
    fill: "url(#prefix__linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.29 524.07a2.35 2.35 0 001.39 1.93 7.39 7.39 0 006.7 0 2.36 2.36 0 001.39-1.94v-36.61c0-15-11.59-33.46-26.4-42-8.49-4.9-16.84-5.7-22.92-2.19-5.31 3.07-8.23 8.91-8.23 16.45v36.78a2.34 2.34 0 001.39 1.93 7.41 7.41 0 006.71 0 2.36 2.36 0 001.39-1.93V459.7c0-2.84.6-6.57 3.48-8.23s8-.93 13.44 2.18c11.74 6.78 21.66 22.26 21.66 33.8z",
    fill: "url(#prefix___30-40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.54 543.11l-3.07-1.77L359 495.47a1.43 1.43 0 00-1.37-.17 1.37 1.37 0 00-.65 1.33v79a4.12 4.12 0 00.65 2.07 4.07 4.07 0 001.37 1.42L438.47 625l3.07 1.77a1.46 1.46 0 001.37.17 1.38 1.38 0 00.65-1.33v-79a4.12 4.12 0 00-.65-2.07 4 4 0 00-1.37-1.43z",
    fill: "url(#prefix__linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.57 552.62a13.87 13.87 0 00-6.28-10.88c-3.47-2-6.29-.38-6.29 3.63a13.25 13.25 0 002.33 7L394 567.13l12.57 7.25-2.33-17.47c1.42-.51 2.33-2.01 2.33-4.29z",
    fill: "url(#prefix__linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.91 543.92a5.29 5.29 0 00-1.79-1.82l-3.07-1.77-79.44-45.87-.29-.12-1.69 1a1 1 0 01.47-.11 1.83 1.83 0 01.9.28l79.44 45.87 3.07 1.77a4 4 0 011.37 1.41c.08.12.14.26.21.39l1-.58c-.04-.18-.09-.32-.18-.45z",
    fill: "url(#prefix__White_100_-0_)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-75",
    d: "M281.57 349.8l5.43 67.25 11.14-27.5a11 11 0 000-8.28c-1-2.61-6.48-20.46-7.72-22.47a22.31 22.31 0 00-8.86-9l-.22 24.93 5.48 12a4 4 0 01.21 2.67l-5.69 20.6zM281.21 566s-12.66-7.32-11.76-14.55c.45-3.43 1.52-8.75 2.58-14.67 1.76-9.87 3.8-21.35 4.67-28.27 1.22-9.84 1.42-7.78 2-14.21.71-7.29.44-7.32.7-9.41l4.94-41.28-24.49-3.92 2.45 52.16c0 1 .06 2 .1 3a40.85 40.85 0 01-.65 7.84c-.19 1.14-.24 2.42-.43 3.81-1.51 10.83-1.92 29.76-1.94 32.8 0 5.24-.25 8.2-.25 8.2a21.12 21.12 0 01-2 7.88l-.19.46c.12 5.87 6 7.8 6 7.8a44.7 44.7 0 0110.87 5.44c2.63 1.82 4.86 2.5 7.44 1.09 2.31-1.3.89-3.4-.1-4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-76",
    d: "M261.15 516.57c6.33-27.67 17.75-21.87 18.06-26.91l-16.83 3.27c.43 3.94-1.56 20.93-2.13 26.31.09 0 .22-.22.35-.52a14.42 14.42 0 00.55-2.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-77",
    d: "M289.81 573.39c-.11-2.81-9-7.61-9-7.61 1 .73 2.36 2.79.1 4.07-2.54 1.38-4.72.71-7.31-1.08a44.28 44.28 0 00-10.67-5.34s-5.76-1.89-5.88-7.66l-.13.36c-.07.18-.13.36-.19.53a16.69 16.69 0 00-.64 2.62 13.83 13.83 0 00-.16 2.14.28.28 0 000-.09v.41a8.1 8.1 0 00.21 1.42 7.14 7.14 0 01-.21-1.42v1a5.67 5.67 0 002.9 5.25 1 1 0 01.52.88v4.45c.11.78 1.86.78 2 0v-4c.11-1.1 1.88-.33 2.58-.28a31.62 31.62 0 016.37 2.58c4.22 1.92 8 5.25 12.87 5.32 2.11.12 6.62-.88 6.7-2.76v-.77zm-4.31 2.28a8 8 0 002.45-.44 8 8 0 01-2.45.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-78",
    d: "M289.8 573.39c-.11-2.81-9-7.64-9-7.64 1 .74 2.37 2.82.11 4.1-2.54 1.38-4.72.71-7.31-1.08a44.28 44.28 0 00-10.67-5.34s-5.76-1.89-5.88-7.66l-.13.36c-.11.29-.23.58-.32.88a6.45 6.45 0 01.21-.62 15.49 15.49 0 00-.74 3v-.27a14.5 14.5 0 00-.18 2.28.28.28 0 000-.09v.41a6.4 6.4 0 00.91 3.14c2.07 3.32 6.55 2.11 9.64 3.72 4 1.61 7.72 3.93 11.64 5.92.51.2 1 .37 1.53.56h.14a14.94 14.94 0 003.32.54c2.12 0 4.55.23 6.25-1.27a1.19 1.19 0 00.46-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-76",
    d: "M279.14 489.68z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "prefix__cls-77",
    cx: 244.95,
    cy: 586.07,
    rx: 9.61,
    ry: 6.41,
    transform: "rotate(-88.16 244.923 586.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-78",
    d: "M251.55 572.91c0-2.37-2.13-4.43-5-4.67a5.22 5.22 0 00-5.54 3.18 73.89 73.89 0 00-2.49 13.44v.34c-.1 5.21 2.6 9.49 6.09 9.6s6.55-4.09 6.72-9.39l.18-12.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-75",
    d: "M245.76 486c-2.13 41.53-2 74.42-4.61 86.95a80.25 80.25 0 00-1.69 10.54 1.44 1.44 0 001.36 1.51c2.42-.69 5.72-.85 8 .45a1.46 1.46 0 002-1.24c.92-34.21 7-41.71 13.91-95.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-78",
    d: "M244.58 403.14c-3.05 8.5-9.25 22.24-6 40.51 4.19 23.54 4.18 33.11 4.16 40.72a7.13 7.13 0 003.27 6c10.57 6.83 35.93 3.44 36.67-6 1-13.12 4.33-35.61 5.82-45.89 2.41-16.53.37-26.22-3.43-37.63 0 0-.59 9.63-17.63 9.6-15.71.03-22.86-7.31-22.86-7.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.2 370.87a28.93 28.93 0 01-1.8-4 12 12 0 01-.59-3.2c-.06-.93-.16-1.86-.29-2.78-.91-6.08-3.2-10.16-5.95-11.86-4.06-2.52-16.93-9.95-28.37-2.58-6.63 4.28-10.81 8.61-17.45 14.2a3.24 3.24 0 00-.86 3.85l3 7.24a107.13 107.13 0 017.69 31.37s6.84 8.68 23.92 7.58 16.57-9.82 16.57-9.82l-.61-12.24c-.06-1-.08-1.93-.07-2.89 7.08-1.6 7.78-9.32 4.81-14.87z",
    fill: "#6ea6ff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-75",
    d: "M252.2 346.48c-3.46 2.81.61 7.87 5.72 11.79 4.29 3.3 9.31 5.8 11.2 5.51a3.65 3.65 0 002-1.53 14.32 14.32 0 001.72-12.95 13.23 13.23 0 00-3.51-5.13s.3-8.54.54-15.71a3.68 3.68 0 00-2.06-3.1 12.3 12.3 0 00-7-1.41c-2.69.24-5.15 1.39-5.73 4-.22 6.28-.25 7.08-.38 10.91l-.12 3.43a7.41 7.41 0 01-2.38 4.19z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "prefix__cls-80",
    width: 24,
    height: 41,
    transform: "translate(250 323)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 404.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-75",
    d: "M265.31 305.37a16.71 16.71 0 00-17.41 16l-.44 10.24a16.7 16.7 0 1033.36 1.39l.45-10.24a16.71 16.71 0 00-15.96-17.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-81",
    d: "M249.63 315.19a9.16 9.16 0 007.28 2.8 8.88 8.88 0 00.77-17.6 9.18 9.18 0 00-7.5 2.16 9.08 9.08 0 00-2.72 8 8.65 8.65 0 002.17 4.64z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "prefix__cls-80",
    width: 19,
    height: 19,
    transform: "translate(247 300)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsSAAALEgHS3X78AAADaUlEQVQ4T51UTU/rRhS9djyO7YydDwguboD2iQ+VSs2iQWJBNl2y5Xd22yWb10WlhsVD4iHyqkRBkOI4dWyPP2fscRdgCpRueqSRrCvP8TnnXl+hLEt4D4QQTCmVkyRROeeiJEm5YRgBxjh69wIASG8Lvu8bQRAYGOOwKIraw8PDV5RSmXMuiqLILcuam6Zpq6qa/icZ51xwHKe7XC7XwzDEURQ1PM9reZ7XyrKsLooi7/f7n57eFdM0rSuKkr0kE6sHSqlMKZUZY2gymXwAABAEoQQAKIqiliSJOhqNBufn5z/d3NwcRFHUgDd4ZXM8Hu+7rttJkkQdj8f7q9Wq7bpuJwxDzBhDCCGGMQ5t2zZPT09/QQgxwzDIK7LpdPpNHMdanucSAMDt7e32fD63BEEoHcfpEkL0PM8lRVHSdru9KoqiNhqNBrIsU0mSZpqmJa+UqaqauK7bmU6n387nc2uxWGwIglDatm1GUdRot9urPM+lNE2VMAxxEATGbDbbwRiHjLGg2WwGEgBAHMfa9fX1d2EY4ionxhjKsqye57lEKZXv7u56CCGm6zrJsqwOAJCmqbK2tvbX1tbW3bOyJEnUIAiMIAgM13U7y+Vy3XGcLmMM+b7fJIToVWYVUWU5jmPtVWaUUjmOY40QoodhiAkhOiFEp5TKhBA9iqIG51zknIuKoqRFUdTKshQ452IURQ1CCNZ1PRQBHuemspOmqcIYQwCPIwEAUJalkOe5xBhDaZoqLz88mUw+XF1dff+sTBRFDgBQr9ezWq1WVJm9PEVRSO/V8zyXqimQAABkWaZ7e3tfbNs2F4vFBkKIIYSY7/tNzrmIEGIAAFW9OsPh8OPBwcFNr9f7pwGWZc09z2sZhhH0er07x3G6vu83syyrS5KUVxarbg6Hw4/L5XJd13WiqmrSarW8Z7Jut+tsbm7+GUVRwzRN+/Dw8HOapgrAY/srS5Uay7Lmx8fHv7VaLU/XdVJtEulJfr6zszMTBKF8mZ/ruh3OuXh5efkDYwwdHR393ul03N3d3T/6/f4n0zTtZrMZwBOe/wCMcbS9vX0ryzJtNBqRYRhBEARGHMfaycnJr/f3919rmhafnZ39fHFx8eP+/v4XeAPhveXoOM76YrHYSJJEfbnLZFmmg8Hg4l8XnvAu2f/F39fINtG4P6L+AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-81",
    d: "M253.18 322.85c3.58-7 13.7-2 18.2-4.27 5.87-3 8.92-1.57 8.73-2.74a16.83 16.83 0 00-14.94-10.66c-9.33-.16-17.1 6.57-17.57 16.11l-.36 8.26c.97.76 2.76-.45 5.94-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.52 360.92c.13.92.23 1.85.29 2.78a12 12 0 00.59 3.2 28.93 28.93 0 001.8 4c2.7 5.05 2.35 11.89-3.08 14.31l.71 1.54.09.23a9.34 9.34 0 004.87-4.79c1.6-3.52 1.26-8.19-.88-12.2a26.28 26.28 0 01-1.68-3.71 9.65 9.65 0 01-.49-2.68c-.06-1-.17-2-.31-2.93q-.14-.9-.3-1.74a13.38 13.38 0 00-6.49-9.06h-.05c2.29 1.95 4.14 5.74 4.93 11.05z",
    opacity: 0.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-76",
    d: "M285.55 402.38c.22.66.42 1.32.62 2 1.92.63 3.72 1.2 5.29 1.68l.64-1.56c-1.9-.61-4.1-1.33-6.55-2.12zM287.94 415h-.07a1.84 1.84 0 00-.67-.3l-2.58-.54-16.07-3.36-1-.21-6.69-1.39a16.45 16.45 0 01-9.51-5.89v-.06a122.09 122.09 0 01-8.7-12.94 26.21 26.21 0 004 9.43q1.59 2.31 3.36 4.56a18.16 18.16 0 005.48 4.62 17 17 0 002.93 1.29 18.7 18.7 0 002.07.58l25.77 5.4.63.13.08.06.24.15 1.86 1.13c-.09-.72-.18-1.44-.29-2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-75",
    d: "M290.31 416.4a35.22 35.22 0 003.74 2c6.44 2.94 7.48 1.58 11.3-4.4.46-.72 1.45-.64 2.28-.42 1.79.5 5.49 2.59 7.27 3.08a2.14 2.14 0 002.78-2.23 2.29 2.29 0 00-1.24-1.69c-1.77-1-4.74-2.54-7.87-3.91-2.36-1-6-2.42-8.7-2.54-2.31-.1-4.92.78-7.14.13-9.64-2.82-30.42-10.34-31.47-10.65l-.05-.06c-4.68-12.86-12.12-28.63-15.85-32.49-4.33-4.48-10.38-5-12.09-.33-1.62 4.5-.7 10.08 4.89 19.7 3.64 6.27 7.8 13.78 13.15 20.58v.06a16.35 16.35 0 009.51 5.88l26.34 5.51a1.81 1.81 0 01.74.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 277.3a4.86 4.86 0 01-5.55-5.22v-1.26a5.56 5.56 0 1111.11 0v1.26a4.86 4.86 0 01-5.56 5.22zm-1.85-17.18l-2.35-25.67v-16.92h8.41v16.92l-2.35 25.67z",
    fill: "#0062ff"
  }))));
}; // The types and DocGen commentary for the component props,
// in alphabetical order (for consistency).
// See https://www.npmjs.com/package/prop-types#usage.

HTTPErrorSvg403.propTypes = {
  className: string
};